<template>
  <div ref="holder" class="w-100"></div>
</template>

<script>
import FormDetailsConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig";

import PermissionsSet from "@/server/PermissionsSet";
import VBox from "@/components/VBox";
import FooterNavbar from "@/components/navbar/FooterNavbar";
import FormConfig from "@/server/com/silkplm/engine/forms/schema/definition/FormConfig";
import EntitiesList from "@/components/forms/EntitiesList";
import FooterButton from "@/components/navbar/FooterButton";
import FormsActions from "@/components/forms/FormsActions";
import FormsLoader from "@/components/forms/FormsLoader";
import CloseButton from "@/components/navbar/CloseButton";
import TemporaryList from "@/components/forms/TemporaryList"
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import Rpc from "@/Rpc";
import Vue from "vue";
import Renderers, {getComponentClass} from "@/components/forms/renderers/Renderers";
import {cloneDeep} from "lodash/lang";
import FormModel from "@/components/forms/FormModel";


export default {
  name: "AutomaticFieldRenderer",
  props: {
    value: {default: null},
    readOnly: {default: false},
    formField: {default: null},
    fieldConfig: {default: null},
    region: {default: null},
  },

  watch: {
    value: function (val)  {
      if(this.validatedField){
        this.validatedField.value = val;
        this.rendererComponent.$props.validatedField = this.validatedField;
        this.$emit("val-change", this.validatedField.value);
      }
    },
    "formField.isValid": function (val) {

    },
    readOnly: function (val)  {

      // console.log(val);
    },
  },

  async beforeCreate(){

  },
  async created(){

  },
  async mounted(){
    const clazz = getComponentClass(this.fieldConfig.renderer, this.$router);
    let router = this.$router;

    //let props = {...this.$props};
/*
    showFlag: {default: true},
    readOnly: {type: Boolean, default: false},
    editorMode: {type: Boolean, default: false},
    validatedField: {type: ValidatedField, default: null},
    fieldConfig: {type: FormFieldConfig, default: null},
    staticLabel: {default: null},
    isStatic: {default: false},
    openFromGrid: {default: false},
    mode: {default: null},
    withSelect: {type: Boolean, default: false},
 */
    let form = new FormModel(this.formField.validatedForm.formConfig);
    form.fakeModel = true;

    form.newEntitySync();
    let instance = form.originalSource;
    instance.__formModel__ = form;

    let validatedField = form.validatedFieldsByName.get(this.fieldConfig.fieldName);
    validatedField.__hideHints = true;
    validatedField.__inTranslation = true;
    validatedField.value = this.value;
    this.validatedField = validatedField;

    let props = {
      value: this.value,
      showFlag: false,
      readOnly: this.readOnly,
      editorMode: true,
      fieldConfig:  this.fieldConfig,
      validatedField: this.validatedField
    };

    if(!props.context){
      props.context = {}
    }
    props.context['allProps'] = props;
    props.context.isTab = true;

    const rendererComponent = new clazz({
      propsData: {
        ...props,
      }
    });

    this.$children.push(rendererComponent);
    rendererComponent.$parent = this;
    rendererComponent.$root = this.$root;
    rendererComponent.$mount();

    rendererComponent.$on('input', (val) => {
      this.$emit('input', val);
    });

    this.input = rendererComponent;

    this.$refs.holder.appendChild(rendererComponent.$el);

    this.rendererComponent = rendererComponent;
    setTimeout(() => {
      rendererComponent.setReadOnly?.(this.readOnly);
    });
  },
  beforeDestroy() {
    if(this.input) {
      let input = this.input;
      input.beforeUnmount?.();
      input.$destroy?.();
      const index = this.$children.indexOf(input);
      if (index > -1) {
        this.$children.splice(index, 1);
      }
      setTimeout(() => {
        try {
          input?.afterUnmount?.();
        } finally {
          setTimeout(() => {
            input.onDestroy?.();
          });
        }
      });
      this.input = null;
    }
  },
  methods: {
    refresh(val) {
      this.validatedField.value = val;
      this.rendererComponent.$props.validatedField = this.validatedField;
      this.$emit("val-change", this.validatedField.value);
    }
  },

  data: function(){ return {
    validatedField: null,
    /** @type {FormConfig}*/
    //formConfig: FormsLoader.detectFormConfig(this.detailsConfig.detailsViewClass ?? this.detailsConfig.detailsClass),
  }},
}
</script>

<style scoped>

</style>